export default __webpack_public_path__ + "static/media/Group 10390.4048be99.svg";